import React, { useEffect, useRef, useState } from "react";
;
export var Scroller = function (_a) {
    var id = _a.id, _b = _a.className, className = _b === void 0 ? '' : _b, contentUpdated = _a.contentUpdated, resetRequired = _a.resetRequired, _c = _a.hideXscroll, hideXscroll = _c === void 0 ? false : _c, _d = _a.hideYscroll, hideYscroll = _d === void 0 ? false : _d, _e = _a.primarySelector, primarySelector = _e === void 0 ? '' : _e, _f = _a.childrenSelectors, childrenSelectors = _f === void 0 ? [] : _f, children = _a.children, itemHeight = _a.itemHeight, rowsLength = _a.rowsLength;
    var initialX = useRef(0);
    var initialLeft = useRef(0);
    var initialScrollXPos = useRef(0);
    var initialY = useRef(0);
    var initialTop = useRef(0);
    var initialScrollYPos = useRef(0);
    var scrollContainer = useRef(null);
    var parentContainer = useRef(null);
    var childElements = useRef([]);
    var xScrollHolderWidth = useRef(0);
    var xScrollableWidth = useRef(0);
    var xScrollMultiplier = useRef(1);
    var xScrollbarWidth = useRef(0);
    var yScrollHolderHeight = useRef(0);
    var yScrollableHeight = useRef(0);
    var yScrollMultiplier = useRef(1);
    var yScrollbarHeight = useRef(0);
    var scrollbarActiveTimer = useRef(null);
    var scrollbarActiveInterval = useRef(100);
    var _g = useState(null), scrollbarX = _g[0], setScrollbarX = _g[1];
    var _h = useState(null), scrollbarY = _h[0], setScrollbarY = _h[1];
    window.onload = function () {
        setScrollBarParams();
    };
    // construtor
    useEffect(function () {
        hideScrollbars();
        setTimeout(setScrollBarParams, 0);
        window.addEventListener('resize', onResize);
    }, []);
    useEffect(function () {
        if (contentUpdated) {
            setScrollBarParams();
        }
    }, [contentUpdated]);
    useEffect(function () {
        if (resetRequired) {
            resetXScrollPosition();
            resetYScrollPosition();
            correctScrollbarPosition();
        }
    }, [resetRequired]);
    useEffect(function () {
        if (scrollbarX) {
            scrollbarXHandler();
        }
    }, [scrollbarX]);
    useEffect(function () {
        if (scrollbarY) {
            scrollbarYHandler();
            wheelEventHandler(primarySelector || childrenSelectors[0]);
        }
    }, [scrollbarY]);
    var onResize = function (e) {
        setScrollBarParams();
    };
    var hideScrollbars = function () {
        childElements.current = document.querySelectorAll(childrenSelectors.join(','));
        if (childElements.current.length > 0) {
            childElements.current.forEach(function (child) {
                child.style.overflow = 'hidden';
            });
        }
    };
    var setScrollBarXParams = function () {
        parentContainer.current = document.getElementById(id);
        if (parentContainer.current && scrollContainer.current) {
            xScrollHolderWidth.current = parentContainer.current.offsetWidth;
            xScrollableWidth.current = scrollContainer.current.scrollWidth;
            xScrollMultiplier.current = xScrollableWidth.current / xScrollHolderWidth.current;
            xScrollbarWidth.current = xScrollHolderWidth.current / xScrollMultiplier.current;
            var sBar = document.querySelector('#' + id + ' > .x .scrollbar');
            if (sBar) {
                setScrollbarX(sBar);
                sBar.style.width = xScrollbarWidth.current + 'px';
                correctScrollbarPosition();
            }
        }
    };
    var setScrollBarYParams = function () {
        parentContainer.current = document.querySelector('#' + id + ' > .y');
        // console.log(scrollContainer.current?.offsetHeight, yScrollableHeight.current);
        if (parentContainer.current && scrollContainer.current) {
            var oldHeight = yScrollHolderHeight.current;
            yScrollHolderHeight.current = parentContainer.current.offsetHeight;
            if (itemHeight && rowsLength) {
                yScrollableHeight.current = itemHeight * rowsLength;
            }
            yScrollMultiplier.current = yScrollableHeight.current / yScrollHolderHeight.current;
            yScrollbarHeight.current = yScrollHolderHeight.current / yScrollMultiplier.current;
            if (yScrollbarHeight.current < 30) {
                var increaseRate = 30 / yScrollbarHeight.current;
                yScrollMultiplier.current += increaseRate;
                yScrollbarHeight.current = 30;
            }
            var sBar = document.querySelector('#' + id + ' > .y .scrollbar');
            if (sBar) {
                setScrollbarY(sBar);
                sBar.style.height = yScrollbarHeight.current + 'px';
                correctScrollbarPosition();
                if (scrollContainer.current.offsetHeight < yScrollableHeight.current) {
                    sBar.style.display = 'block';
                }
                else {
                    sBar.style.display = 'none';
                }
                if (yScrollHolderHeight.current - oldHeight < 0) {
                    var currentTop = parseInt(sBar.style.top, 10);
                    sBar.style.top = (yScrollHolderHeight.current * currentTop) / oldHeight + "px";
                }
            }
        }
    };
    var setScrollBarParams = function () {
        childElements.current = document.querySelectorAll(childrenSelectors.join(','));
        scrollContainer.current = primarySelector ? document.querySelector(primarySelector) : childElements.current[0];
        setScrollBarXParams();
        setScrollBarYParams();
    };
    var moveXHandler = function (e) {
        var _a;
        var distanceMoved = e.clientX - initialX.current;
        if (scrollbarX) {
            var left = initialLeft.current + distanceMoved;
            if (left >= 0 && left <= xScrollHolderWidth.current - xScrollbarWidth.current) {
                // moves scrollbar
                scrollbarX.style.left = left + "px";
                // scrolls all container
                var distanceScrolled_1 = initialScrollXPos.current + xScrollMultiplier.current * distanceMoved;
                childElements.current.forEach(function (child) {
                    child === null || child === void 0 ? void 0 : child.scroll({ left: distanceScrolled_1 });
                });
            }
        }
        (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.empty(); // clears text selection
    };
    var scrollbarXHandler = function () {
        if (scrollbarX) {
            scrollbarX.addEventListener('mousedown', function (e) {
                initialX.current = e.clientX;
                initialLeft.current = scrollbarX.offsetLeft;
                initialScrollXPos.current = childElements.current[0].scrollLeft;
                scrollbarX.classList.add('scrolling');
                window.addEventListener('mousemove', moveXHandler);
            });
            window.addEventListener('mouseup', function (e) {
                scrollbarX.classList.remove('scrolling');
                window.removeEventListener('mousemove', moveXHandler);
            });
        }
    };
    var resetXScrollPosition = function () {
        childElements.current.forEach(function (child) {
            child === null || child === void 0 ? void 0 : child.scroll({ left: 0 });
        });
    };
    var moveYHandler = function (e) {
        var _a;
        var distanceMoved = e.clientY - initialY.current;
        if (scrollbarY) {
            var top_1 = initialTop.current + distanceMoved;
            if (top_1 >= 0 && top_1 <= yScrollHolderHeight.current - yScrollbarHeight.current) {
                // moves scrollbar
                scrollbarY.style.top = top_1 + "px";
                // scrolls all container
                var distanceScrolled_2 = initialScrollYPos.current + yScrollMultiplier.current * distanceMoved;
                childElements.current.forEach(function (child) {
                    child === null || child === void 0 ? void 0 : child.scroll({ top: distanceScrolled_2 });
                });
            }
        }
        (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.empty(); // clears text selection
    };
    var scrollbarYHandler = function () {
        if (scrollbarY) {
            scrollbarY.addEventListener('mousedown', function (e) {
                var _a;
                initialY.current = e.clientY;
                initialTop.current = scrollbarY.offsetTop;
                initialScrollYPos.current = ((_a = scrollContainer.current) === null || _a === void 0 ? void 0 : _a.scrollTop) || 0;
                scrollbarY.classList.add('scrolling');
                window.addEventListener('mousemove', moveYHandler);
            });
            window.addEventListener('mouseup', function (e) {
                scrollbarY.classList.remove('scrolling');
                window.removeEventListener('mousemove', moveYHandler);
            });
        }
    };
    var resetYScrollPosition = function () {
        childElements.current.forEach(function (child) {
            child === null || child === void 0 ? void 0 : child.scroll({ top: 0 });
        });
    };
    var correctScrollbarPosition = function () {
        // console.log('correctScrollbarsPosition');
        if (scrollContainer.current) {
            if (scrollbarX) {
                var sbxPosition = scrollContainer.current.scrollLeft / xScrollMultiplier.current;
                scrollbarX.style.left = sbxPosition + "px";
            }
            if (scrollbarY) {
                var sbyPosition = scrollContainer.current.scrollTop / yScrollMultiplier.current;
                if (sbyPosition + scrollbarY.offsetHeight > scrollContainer.current.offsetHeight) {
                    scrollbarY.style.top = scrollContainer.current.offsetHeight - scrollbarY.offsetHeight + "px";
                    return;
                }
                scrollbarY.style.top = sbyPosition + "px";
            }
        }
    };
    var wheelEventHandler = function (selector) {
        var container = document.querySelector(selector);
        if (container) {
            container.addEventListener('wheel', function (e) {
                e.preventDefault();
                var xDistanceMoved = e.deltaX;
                var yDistanceMoved = e.deltaY;
                scrollbarActiveTimer.current && clearTimeout(scrollbarActiveTimer.current);
                scrollbarActiveTimer.current = setTimeout(function () {
                    scrollbarX === null || scrollbarX === void 0 ? void 0 : scrollbarX.classList.remove('scrolling');
                    scrollbarY === null || scrollbarY === void 0 ? void 0 : scrollbarY.classList.remove('scrolling');
                }, scrollbarActiveInterval.current);
                // moving x scrollbar
                if (Math.abs(xDistanceMoved) > Math.abs(yDistanceMoved)) {
                    if (xDistanceMoved < 0 || xDistanceMoved > 0) {
                        scrollbarX === null || scrollbarX === void 0 ? void 0 : scrollbarX.classList.add('scrolling');
                    }
                    var xPos = (container === null || container === void 0 ? void 0 : container.scrollLeft) || 0;
                    var xDistanceScrolled_1 = xPos + xDistanceMoved;
                    childElements.current.forEach(function (child) {
                        child === null || child === void 0 ? void 0 : child.scroll({ left: xDistanceScrolled_1 });
                    });
                }
                // moving y scrollbar
                if (Math.abs(yDistanceMoved) > Math.abs(xDistanceMoved)) {
                    if (yDistanceMoved < 0 || yDistanceMoved > 0) {
                        scrollbarY === null || scrollbarY === void 0 ? void 0 : scrollbarY.classList.add('scrolling');
                    }
                    var yPos = (container === null || container === void 0 ? void 0 : container.scrollTop) || 0;
                    var yDistanceScrolled_1 = yPos + yDistanceMoved;
                    childElements.current.forEach(function (child) {
                        child === null || child === void 0 ? void 0 : child.scroll({ top: yDistanceScrolled_1 });
                    });
                }
                correctScrollbarPosition();
            });
        }
    };
    return (React.createElement("div", { className: "scroll-container " + className, id: id },
        children,
        React.createElement("div", { className: "scrollbar-container x " + (hideXscroll ? 'hidden' : '') },
            React.createElement("div", { className: "scrollbar" })),
        React.createElement("div", { className: "scrollbar-container y " + (hideYscroll ? 'hidden' : '') },
            React.createElement("div", { className: "scrollbar" }))));
};
